// extracted by mini-css-extract-plugin
export default {"imageAttachmentContent":"AttachmentBoxStyles_imageAttachmentContent__06V5Y","downloadIcon":"AttachmentBoxStyles_downloadIcon__f0po5"};